import React, { PropsWithChildren, ReactNode } from 'react';
import classnames from 'classnames';
import iPhoneXFrame from './img/iPhoneX.svg';
import iPhone17Frame from './img/iphone17mockup.png';
import './DeviceWrapper.scss';

export type DeviceWrapperProps = PropsWithChildren<{
  device?: 'iPhoneX' | 'iPhone17';
  withSafeArea?: boolean;
  overlay?: ReactNode;
}>;

const deviceFrameConfig = {
  iPhoneX: {
    frame: iPhoneXFrame,
    height: 846,
    width: 417,
    className: 'iphonex',
  },
  iPhone17: {
    frame: iPhone17Frame,
    height: 2644,
    width: 1280,
    className: 'iphone17',
  },
} as const;

/** A wrapper for previewing content in a device frame.
 * Requires a node for the content.
 */
const DeviceWrapper: React.FC<DeviceWrapperProps> = props => {
  const { children, device = 'iPhoneX', withSafeArea = true, overlay } = props;
  const currentDevice = deviceFrameConfig[device];

  return (
    <div
      className={classnames(
        'device-wrapper-container',
        `device-wrapper-container--${currentDevice.className}`
      )}
    >
      <div
        className={classnames(
          'device-wrapper',
          `device-wrapper--${currentDevice.className}`
        )}
      >
        <img
          alt=""
          className="frame"
          height={currentDevice.height}
          src={currentDevice.frame}
          width={currentDevice.width}
        />
        <div
          className={classnames(
            'preview-container',
            `preview-container--${currentDevice.className}`,
            {
              'preview-container--with-safe-area': withSafeArea,
            }
          )}
        >
          {children}
        </div>
        {overlay && <div className="device-wrapper-overlay">{overlay}</div>}
      </div>
    </div>
  );
};

export default DeviceWrapper;
